import { __rest, __assign } from './../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
import styles from '../../components/base/HorizonCarousel/index.module.scss.js';
import classNames from './../../external_lib/classnames/index.js';
import AntCarousel from './../../external_lib/antd/es/carousel/index.js';
function HorizonCarousel(_a) {
  var className = _a.className,
    children = _a.children,
    _b = _a.centerMode,
    centerMode = _b === void 0 ? false : _b,
    _c = _a.focusOnSelect,
    focusOnSelect = _c === void 0 ? false : _c,
    carouselRef = _a.carouselRef,
    restProps = __rest(_a, ["className", "children", "centerMode", "focusOnSelect", "carouselRef"]);
  if (!Array.isArray(children)) {
    console.error('children of HorizonCarousel must be of type array');
    return null;
  }
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(AntCarousel, __assign({
    infinite: false,
    className: classNames(className, styles.horizonCarousel, centerMode && styles.horizonCarouselCentered, focusOnSelect && centerMode && styles.enablePointerEvents),
    dots: {
      className: classNames(styles.carouselDots, children.length < 2 && styles.carouselDotsHidden)
    },
    centerMode: centerMode,
    focusOnSelect: focusOnSelect,
    ref: carouselRef
  }, restProps), children));
}
export { HorizonCarousel as default };
//# sourceMappingURL=index.js.map
